var accordion = document.getElementsByClassName("accordion");
var iacc;

for (iacc = 0; iacc < accordion.length; iacc++) {
    accordion[iacc].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.previousElementSibling;
        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        } 
  });
}   